import store from '../store'
import { Platform } from 'quasar'

const routes = [
  {
    path: '/',
    component: () => import('layouts/Open.vue'),
    children: [
      {
        path: 'institutional/about',
        name: 'login_about',
        component: () =>
          Platform.is.mobile
            ? import('pages/about/LoginAboutMobile.vue')
            : import('pages/about/LoginAbout.vue'),
        meta: { title: 'about', parent: 'open' },
      },
      {
        path: 'institutional/cookies_policy',
        name: 'cookies_policy',
        component: () =>
          Platform.is.mobile
            ? import('pages/policy/CookiesPolicyMobile.vue')
            : import('pages/policy/CookiesPolicy.vue'),
        meta: { title: 'about', parent: 'open' },
      },
      {
        path: 'institutional/support',
        name: 'login_support',
        component: () =>
          Platform.is.mobile
            ? import('pages/support/LoginSupportMobile.vue')
            : import('pages/support/LoginSupport.vue'),
        meta: { title: 'support', parent: 'open' },
      },
      {
        path: '',
        name: 'login',
        component: () =>
          Platform.is.mobile
            ? import('pages/login/LoginMobile.vue')
            : import('pages/login/LoginDesktop.vue'),
        meta: { title: 'login', parent: 'open' },
      },
      {
        path: 'maintenance-login',
        name: 'maintenance_login',
        component: () =>
          Platform.is.mobile
            ? import('pages/login/LoginMobile.vue')
            : import('pages/login/LoginDesktop.vue'),
        props: true,
      },
      {
        path: 'login-redirect-v2',
        name: 'login_redirect_v2',
        component: () =>
          Platform.is.mobile
            ? import('pages/login/LoginMobile.vue')
            : import('pages/login/LoginDesktop.vue'),
        meta: { title: 'login_redirect_v2', parent: 'open' },
      },
      {
        path: 'webservice-login/:token',
        name: 'webservice-login',
        component: () =>
          Platform.is.mobile
            ? import('pages/login/LoginMobile.vue')
            : import('pages/login/LoginDesktop.vue'),
        meta: { title: 'webservice-login', parent: 'open' },
      },
      {
        path: 'institutional/privacy-policy',
        name: 'login_privacy_policy',
        component: () =>
          Platform.is.mobile
            ? import('pages/privacy_policy/LoginPrivacyPolicyMobile.vue')
            : import('pages/privacy_policy/LoginPrivacyPolicy.vue'),
        meta: { title: 'privacy_policy', parent: 'open' },
      },
      {
        path: 'set-password/:username/:uidb64/:token',
        name: 'set_password',
        component: () =>
          Platform.is.mobile
            ? import('pages/set_password/SetPasswordMobile.vue')
            : import('pages/set_password/SetPasswordDesktop.vue'),
        meta: { title: 'set_password', parent: 'open' },
      },
      {
        path: 'request-password/',
        name: 'request_password',
        component: () =>
          Platform.is.mobile
            ? import('pages/request_password/RequestPasswordMobile.vue')
            : import('pages/request_password/RequestPasswordDesktop.vue'),
        meta: { title: 'request_password', parent: 'open' },
        props: false,
      },
      {
        path: 'recover-password/:username/:uidb64/:token',
        name: 'recover_password',
        component: () =>
          Platform.is.mobile
            ? import('pages/set_password/SetPasswordMobile.vue')
            : import('pages/set_password/SetPasswordDesktop.vue'),
        meta: { title: 'recover_password', parent: 'open' },
        props: false,
      },
      {
        path: 'register',
        name: 'register',
        component: () => import('pages/register/Register.vue'),
        meta: { title: 'register', parent: 'open' },
      },
      {
        path: 'register-success',
        name: 'register-success',
        component: () => import('pages/register/RegisterSuccess.vue'),
        meta: { title: 'register', parent: 'open' },
      },
      {
        path: 'institutional/terms-and-conditions',
        name: 'login_terms_and_conditions',
        component: () =>
          Platform.is.mobile
            ? import(
                'pages/terms_and_conditions/LoginTermsAndConditionsMobile.vue'
              )
            : import('pages/terms_and_conditions/LoginTermsAndConditions.vue'),
        meta: { title: 'terms_and_conditions', parent: 'open' },
      },
    ],
    beforeEnter: (to, from, next) => {
      if (process.env.PROJECT_FOLDER === 'itpiry') {
        try {
          wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
        } catch (err) {
          console.log(err)
        }
      }

      if (store.getters['common/access_token']) {
        let clients = store.getters['params/clients']
        let id_user_client_selected =
          store.getters['common/id_user_client_selected']

        var obj = clients.find((obj) => obj.id === id_user_client_selected)
        if (obj) {
          next({ name: obj.home_route, query: to.query })
        } else {
          next({ name: 'courses', query: to.query })
        }
      } else {
        store.dispatch('common/SET_REDIRECT_URL', [to.query])
        clearUserData()
        next()
      }
    },
  },
  {
    path: '/',
    component: () => import('layouts/IntelFirstAccess.vue'),
    children: [
      {
        path: 'intel-first-access',
        name: 'intel_first_access',
        component: () =>
          import('pages/intel_first_access/IntelFirstAccess.vue'),
        meta: { title: 'intel_first_access', parent: 'open' },
      },
      {
        path: 'intel-login-redirect',
        name: 'intel_login_redirect',
        component: () =>
          import('pages/intel_login_redirect/IntelLoginRedirect.vue'),
        meta: { title: 'intel_login_redirect', parent: 'open' },
      },
    ],
    beforeEnter: (to, from, next) => {
      if (process.env.PROJECT_FOLDER === 'itpiry') {
        try {
          wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
        } catch (err) {
          console.log(err)
        }
      }

      next()
    },
  },
  {
    path: '/',
    component: () => import('layouts/Closed.vue'),
    children: [
      {
        path: 'home',
        name: 'home',
        component: () =>
          Platform.is.mobile
            ? import('pages/home/HomeMobile.vue')
            : import('pages/home/HomeDesktop.vue'),
        meta: { title: 'home', parent: 'closed' },
      },
      {
        path: 'reward-store',
        name: 'reward_store',
        component: () => import('pages/reward_store/RewardStore.vue'),
        meta: { title: 'reward_store', parent: 'closed' },
      },
      {
        path: 'reward-store/details/:id/',
        name: 'reward_details',
        component: () => import('pages/reward_store/RewardDetails.vue'),
        meta: { title: 'reward_store', parent: 'closed' },
      },
      {
        path: 'points-table',
        name: 'points_table',
        component: () => import('pages/points_table/PointsTable.vue'),
        meta: { title: 'points_table', parent: 'closed' },
      },
      {
        path: 'campaigns',
        name: 'campaigns',
        component: () => import('pages/campaigns/Campaigns.vue'),
        meta: { title: 'campaigns', parent: 'closed' },
      },
      {
        path: 'profile',
        name: 'profile',
        component: () =>
          Platform.is.mobile
            ? import('pages/profile/ProfileMobile.vue')
            : import('pages/profile/ProfileDesktop.vue'),
        meta: { title: 'profile', parent: 'closed' },
      },
      {
        path: 'events',
        name: 'events',
        component: () => import('pages/events/Events.vue'),
        meta: { title: 'events', parent: 'closed' },
      },
      {
        path: 'terms-and-conditions',
        name: 'terms_and_conditions',
        component: () =>
          import('pages/terms_and_conditions/TermsAndConditions.vue'),
        meta: { title: 'terms_and_conditions', parent: 'closed' },
      },
      {
        path: 'faq',
        name: 'faq',
        component: () => import('pages/faq/Faq.vue'),
        meta: { title: 'faq', parent: 'closed' },
      },
      {
        path: 'support',
        name: 'support',
        component: () =>
          Platform.is.mobile
            ? import('pages/support/SupportMobile.vue')
            : import('pages/support/Support.vue'),
        meta: { title: 'support', parent: 'closed' },
      },
      {
        path: 'privacy-policy',
        name: 'privacy_policy',
        component: () => import('pages/privacy_policy/PrivacyPolicy.vue'),
        meta: { title: 'privacy_policy', parent: 'closed' },
      },
      {
        path: 'about-the-program',
        name: 'about-the-program',
        component: () => import('pages/about/About.vue'),
        meta: { title: 'about_the_program', parent: 'closed' },
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('pages/about/PageAbout.vue'),
        meta: { title: 'about', parent: 'closed' },
      },
      {
        path: 'contact-us',
        name: 'contact-us',
        component: () => import('pages/contact_us/ContactUs.vue'),
        meta: { title: 'contact_us', parent: 'closed' },
      },
      {
        path: 'insert-sales',
        name: 'insert_sales',
        component: () => import('pages/insert_sales/InsertSales.vue'),
        meta: { title: 'insert_sales', parent: 'closed' },
      },
      {
        path: 'upload-photos',
        name: 'upload_photos',
        component: () => import('pages/upload_photos/UploadPhotos.vue'),
        meta: { title: 'upload_photos', parent: 'closed' },
      },
    ],
    beforeEnter: (to, from, next) => {
      if (process.env.PROJECT_FOLDER === 'itpiry') {
        try {
          wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
        } catch (err) {
          console.log(err)
        }
      }

      if (!store.getters['common/access_token']) {
        clearUserData()
        if (to.query.hasOwnProperty('token')) {
          store.dispatch('redirect/SET_TOKEN', [to.query.token])
        }
        store.dispatch('redirect/SET_REDIRECT', [to.path])
        next({ name: 'login' })
      } else {
        if (to.query.hasOwnProperty('token')) {
          clearUserData()
          store.dispatch('redirect/SET_TOKEN', [to.query.token])

          store.dispatch('redirect/SET_REDIRECT', [to.path])
          next({ name: 'login' })
        } else if (store.getters['redirect/redirect'] !== '') {
          let redirect = store.getters['redirect/redirect']
          store.dispatch('redirect/SET_REDIRECT', [''])

          next({ path: redirect })
        } else {
          next()
        }
      }
    },
  },
]

// Always leave this as last one
routes.push({
  path: '*',
  component: () => import('pages/Error404.vue'),
})

export default routes

function clearUserData() {
  store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])
  store.dispatch('common/SET_USER_DATA', [
    '',
    '',
    '',
    false,
    '',
    '',
    '',
    '',
    '',
    '',
    false,
    [],
    [],
    '',
    [],
    '',
    [],
    [],
    null,
    '',
    [],
    '',
    '',
  ])
}
